import initFetchContent from './components/fetch-content';
import initLoadMore from './components/load-more';

const fetchContainer = document.querySelector('.js-fetch-container');
const fetchLinks = document.querySelectorAll('.js-fetch');

if (fetchContainer && (fetchLinks && fetchLinks.length > 0)) {
    initFetchContent(fetchContainer, fetchLinks);
}

const loadMoreDiv = document.querySelector('.js-load-more-target');
const loadMoreBtn = document.querySelector('.js-load-more-button');

if (loadMoreDiv && loadMoreBtn) {
    initLoadMore(loadMoreDiv, loadMoreBtn);
}
